import React from 'react';
import { connect } from 'react-redux';
import { IAppState } from '../../../../../state/reducers';
import VaultButton from '../../../VaultButton';
import {
  closeSocialPublishDialog,
} from '../../../../../state/publishAssets';
import {
  IProps,
  IStateProps,
  IDispatchProps,
} from './interfaces';
import {
  DialogActionsOverride,
  ActionContainer,
} from '../../../styles/dialog';

class SocialDialogActions extends React.Component<IProps> {
  handlePublish = async () => {
    const {
      socialPublishing: {
        settings: publishSettings,
        metadata: publishMetadata,
      },
      onPublish,
      setIsProcessing,
      closeSocialPublishDialogConnect,
    } = this.props;
    setIsProcessing(true);

    await onPublish([publishSettings], publishMetadata);
    closeSocialPublishDialogConnect();

    setIsProcessing(false);
  };

  render() {
    const {
      socialPublishing: {
        metadata: {
          title,
          whatIsHappening,
        },
      },
      fromClipper,
      closeSocialPublishDialogConnect,
      isProcessing,
    } = this.props;

    return (
      <DialogActionsOverride disableSpacing>
        <ActionContainer>
          <VaultButton
            variant="plainOnPaper"
            onClick={closeSocialPublishDialogConnect}
            data-auto="SocialCancelBtn"
            disabled={isProcessing}
          >
            Cancel
          </VaultButton>
          <VaultButton
            variant="primaryOnWhite"
            onClick={this.handlePublish}
            disabled={isProcessing || (fromClipper ? !title : !(title || whatIsHappening))}
            data-auto="SocialPublishBtn"
          >
            Publish
          </VaultButton>
        </ActionContainer>
      </DialogActionsOverride>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  socialPublishing: state.publishSelectedAssetsToEndPoints.socialPublishing,
});

const mapDispatchToProps: IDispatchProps = {
  closeSocialPublishDialogConnect: closeSocialPublishDialog,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SocialDialogActions);
